import RemuneracaoMedicaApi from './Services/RemuneracaoMedicaApi'
import AntecipacaoRecebiveisApi from './Services/AntecipacaoRecebiveisApi'
import RemuneracaoMedicaChatApi from './Services/RemuneracaoMedicaChatApi'

export default {
  RemuneracaoMedicaApi,
  RemuneracaoMedicaChatApi,
  AntecipacaoRecebiveisApi,
}
